import styled from "styled-components";
import WhatWeDoServiceHeader from "../WhatWeDoHeader";
import CustomSplitText from "@/mono/components/CustomSplitText";
import ColumnRow, {
  columnRowTypeNames,
} from "components/pages/contentSections/ColumnRow";
import BorderedIcon from "components/BorderedIcon";
import { TransitionLink } from "mono/components/TransitionLink";

export default function WhatWeDoServicePhotoVideo() {
  return (
    <Wrapper>
      <WhatWeDoServiceHeader
        fullServiceName="Photo / Video"
        service="Photo /"
        serviceBottom="video"
      >
        <div>
          <CustomSplitText tag="p">
            Sterke foto’s en video’s maken jouw merk herkenbaar, betrouwbaar en
            onvergetelijk. Bij Nine draait visuele content om beelden die emotie
            oproepen, overtuigen en jouw verhaal tot leven brengen.
          </CustomSplitText>
          <CustomSplitText tag="p">
            Professionele visuals vergroten aandacht, bouwen vertrouwen op en
            versterken je merk. Met strategisch ontworpen en perfect afgewerkte
            content zorgen we dat jouw boodschap blijft hangen.
            <br />
            <br />
          </CustomSplitText>
          <CustomSplitText tag="p">
            Zo maken we van jouw merk een visueel verhaal dat raakt én resultaat
            oplevert.
          </CustomSplitText>
        </div>

        <TransitionLink href="/service/photo-video">
          <BorderedIcon text={"More about <strong>photo / video</strong>"} />
        </TransitionLink>
      </WhatWeDoServiceHeader>
      <ColumnRow
        data={{
          columns: [
            {
              __typename: columnRowTypeNames.image,
              image: {
                url: "/images/what-we-do/photo.jpeg",
              },
              width: 100,
            },
          ],
        }}
      />
      <ColumnRow
        data={{
          columns: [
            {
              __typename: columnRowTypeNames.image,
              image: {
                url: "/images/what-we-do/photo2.mp4",
              },
              width: 100,
            },
          ],
        }}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin-bottom: 150rem;
  .icon-container {
    margin-top: 150rem;
  }
`;
